<div
  routerLink="/vip"
  class="vip-club-banner group relative flex h-[25.6rem] w-[28.8rem] cursor-pointer rounded-[2.4rem] bg-[#050813] custom-transition-all hover:bg-[#050813] lg:h-[16.2rem] lg:w-full lg:rounded-[1.4rem]"
>
  <div class="relative h-full w-full overflow-hidden rounded-[2.4rem] p-[2.4rem] lg:rounded-[1.4rem] lg:p-[1.6rem]">
    <div class="flex h-full flex-col justify-between">
      <div class="flex flex-col items-start space-y-[1rem] lg:space-y-[0.4rem]">
        <span class="text-[2rem] font-450 leading-[2.6rem] text-white lg:text-[1.5rem] lg:leading-[2.2rem]"
          >VIP Club</span
        >
        <div
          class="flex h-[2.4rem] items-center justify-center rounded-[1.5rem] bg-[#F05B97] px-[0.7rem] lg:h-[2rem] lg:rounded-[2.4rem]"
        >
          <span i18n="@@main.vipclub.soon" class="text-[0.9rem] font-400 uppercase leading-[1.2rem] text-[#311F13]"
            >Скоро</span
          >
        </div>
      </div>
      <button
        class="flex h-[3rem] w-[5rem] items-center justify-center rounded-[1rem] bg-[#C3A5FF] opacity-80 custom-transition-all group-hover:w-[5.6rem] group-hover:bg-[#D3BEFF] lg:h-[2.6rem] lg:w-[3.8rem] lg:rounded-[0.8rem]"
      >
        <i class="icon icon_arrow-right-alt text-[2.4rem] !text-dark-250 lg:text-[1.8rem]"></i>
      </button>
    </div>
    <div class="vip-club_man"></div>
    <div class="vip-club_shadow"></div>
  </div>
  <div class="vip-club_ball"></div>
  <div class="vip-club_diamond"></div>
  <div class="vip-club_tape"></div>
</div>
